import { render, staticRenderFns } from "./Article33.vue?vue&type=template&id=1661ae3a&"
import script from "./Article33.vue?vue&type=script&lang=js&"
export * from "./Article33.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports